<template>
  <div id="authority">
    <div>
      <template v-for="(time,index) in datalist">
        <el-table-column :key="index">
          <label class="label">{{time.Name}}</label>
          <el-checkbox class="label"></el-checkbox>
          <el-checkbox
            class="label"
            v-for="(times,index) in time.List"
            :key="index"
            v-model="times.Status"
          >{{times.Action}}</el-checkbox>
        </el-table-column>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "authority",
  data() {
    return {
      datalist: [
        {
          Name: "销售订单",
          List: [
            { Id: 1, Action: "查看", Status: true },
            { Id: 2, Action: "打印", Status: true },
            { Id: 3, Action: "保存", Status: true },
            { Id: 4, Action: "复制", Status: true }
          ]
        },
        {
          Name: "出库",
          List: [
            { Id: 1, Action: "查看", Status: true },
            { Id: 2, Action: "打印", Status: true },
            { Id: 3, Action: "保存", Status: true },
            { Id: 4, Action: "复制", Status: true }
          ]
        },
        {
          Name: "销售订单",
          List: [
            { Id: 1, Action: "查看", Status: true },
            { Id: 2, Action: "打印", Status: true },
            { Id: 3, Action: "保存", Status: true },
            { Id: 4, Action: "复制", Status: true }
          ]
        },
        {
          Name: "销售库单",
          List: [
            { Id: 1, Action: "查看", Status: true },
            { Id: 2, Action: "打印", Status: true },
            { Id: 3, Action: "保存", Status: true },
            { Id: 4, Action: "复制", Status: true }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="less">
#authority {
  border: 1px solid #ccc;
  border-top: none;
  border-left: none;
  .tables {
    border: 1px solid #ccc;
    height: 32px;
    line-height: 32px;
    border-right: 0px;
    border-bottom: 0px;
    display: inline-block !important;
    width: 80px !important;
    border-collapse: collapse;
  }
  .label {
    border: 1px solid #ccc;
    text-align: center;
    height: 32px;
    line-height: 32px;
    border-right: 0px;
    font-size: 14px;
    border-bottom: 0px;
    display: inline-block !important;
    width: 80px !important;
    border-collapse: collapse;
  }
  .el-checkbox {
    width: 60px;
    text-align: center;
    margin-right: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/authority/authority.vue